import React, { useEffect } from 'react'
import './componentsCss/ListCardAgreements.css'
import Avatar from '../assets/img/hospital.svg'
import api from '../api'
import Loading from './Loading'
import Globals from '../Globals'
import { Link } from 'react-router-dom'
import Normal from '../assets/img/verificado.svg'
import Suspended from '../assets/img/suspended.svg'
import Canceled from '../assets/img/cancelar.svg'
import Pending from '../assets/img/atencao.svg'
import './componentsCss/ListCardShoppers.css'

function ListCardPartners({ search }) {
  const [data, setData] = React.useState([])

  const [loading, setLoading] = React.useState(false)
  const [page, setPage] = React.useState(1)
  const [finalPage, setFinalPage] = React.useState(null)

  const handleScroll = (event) => {
    if (event.target.scrollTop + event.target.clientHeight >= event.target.scrollHeight - 90 && !loading && !(page - 1 === finalPage)) {
      getData()
    }
  }

  const getData = (exception = false, page2 = null) => {

    if (((page > finalPage && finalPage !== null) || loading) && exception === false) {
      // Já carregamos todas as páginas disponíveis ou esta carregando
      return;
    }

    setLoading(true)

    if (search !== "") {
      api.get('/api/affiliatecompany/list?search='  + search + '&page=' + String(page2 === null ? page : page2)).then((response) => {
        var partners = response.data.data
        for (const key in partners) {
          partners[key].mobile = partners[key].mobile.replace(/^(\d{2})(\d{1})(\d{4})(\d{4})/, "($1) $2 $3 - $4")
          partners[key].phone = partners[key].phone.replace(/^(\d{2})(\d{4})(\d{4})/, "($1) $2 - $3")
          partners[key].cnpj_cpf = partners[key].cnpj_cpf.length === 11 ? partners[key].cnpj_cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : partners[key].cnpj_cpf.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
        }

        setData(page2 === null ? data.concat(response.data.data) : response.data.data)
        setFinalPage(response.data.last_page)
        setPage(page + 1)
      }).catch((error) => {
        console.error('Error fetching partners:', error);
      }).finally(() => {
        setLoading(false)
      })

    } else {
      api.get('/api/affiliatecompany/list?page=' + String(page)).then((response) => {
        var partners = response.data.data;
        for (const key in partners) {
          partners[key].mobile = partners[key].mobile.replace(/^(\d{2})(\d{1})(\d{4})(\d{4})/, "($1) $2 $3 - $4")
          partners[key].phone = partners[key].phone.replace(/^(\d{2})(\d{4})(\d{4})/, "($1) $2 - $3")
          partners[key].cnpj_cpf = partners[key].cnpj_cpf.length === 11 ? partners[key].cnpj_cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : partners[key].cnpj_cpf.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
        }

        setData(data.concat(response.data.data))
        setFinalPage(response.data.last_page)
        setPage(page + 1)
      }).catch((error) => {
        console.error('Error fetching agreements:', error);
      }).finally(() => {
        setLoading(false)
      })
    }
  }
  
  useEffect(() => {
    if (search === "") {
        setFinalPage(null)
        setPage(1)
        setData([])

        getData()

    } else {
        getData(true, 1)
    }
}, [search])

useEffect(() => {

    var el = document.getElementsByClassName('scroll-list-container')[0]

    if (el.scrollHeight <= window.innerHeight) {
        getData()
    }

}, [page])


  return (
    <div onScroll={handleScroll} className='container-scroll'>
      <div className="row row-subcontainer scroll-list-container">
        {
          data.length > 0 ? data.map((item, index) => {
            if (item != null) {
              return (

                <Link className='col-12 col-sm-6 col-md-6 col-lg-4' style={{ padding: '0px 10px' }} key={index} to={'/partners/' + item.id}>
                  <div className='card-list-shopper'>

                    <div className='col-3'>
                      {
                        item.image === "" || item.image === null || item.image === undefined ? <div className='avatar-img' >
                          <img alt='avatar' src={Avatar} />
                        </div> : <div style={{ background: 'url(' + Globals.BASE_URL + '/storage/' + item.image + ') 0% 0% / cover', }} alt='shopper' className='card-list-agreements-img' ></div>
                      }
                    </div>
                    <div className='col-9'>
                      <span className='card-list-shopper-name'>{item.name}</span>
                      <span className='card-list-shopper-cnpj_cpf'>{item.cnpj_cpf}</span>
                      <span className='card-list-shopper-mobile'>{item.mobile}</span>
                    </div>
                    {item.status === '0' && <div className='icon-active normal'>
                      <img alt='icon' className='icon-image' src={Normal} />
                    </div>
                    }
                    {item.status === '1' && <div className='icon-active suspended'>
                      <img alt='icon' className='icon-image' src={Suspended} />
                    </div>
                    }
                    {item.status === '2' && <div className='icon-active canceled'>
                      <img alt='icon' className='icon-image' src={Canceled} />
                    </div>
                    }
                    {item.status === '3' && <div className='icon-active pending'>
                      <img alt='icon' className='icon-image' src={Pending} />
                    </div>
                    }
                  </div>
                </Link>
              );
            }
          }) : !loading ? <div><h6 style={{ textAlign: 'center', marginTop: '0px' }}>Sem Clientes</h6></div> : console.info("loading")

        }
        {loading ? <Loading /> : <></>}
      </div>
    </div>

  )
}

export default ListCardPartners;